/* ==========================================================================
   Foot Cardigan, kids organic socks landing (v2) buy box.

   The four colourways are four products. Picking a swatch swaps the gallery,
   the variant ids and the price in place (data comes from #kv2-data, written
   by sections/kids-v2-hero.liquid), and updates the URL so a refresh or a
   share lands on the right product. Adds via /cart/add.js and fires
   `ajaxProduct:added` so the theme's cart drawer and the confetti in
   sub-v2.js both react.
   ========================================================================== */
if (!window.__kv2Init) {
  window.__kv2Init = true;

  (function () {
    'use strict';

    var root = document.querySelector('[data-kv2-buybox]');
    var dataEl = document.getElementById('kv2-data');
    if (!root || !dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var PACKS = {};
    (DATA.packs || []).forEach(function (p) { PACKS[p.handle] = p; });
    if (!Object.keys(PACKS).length) return;

    var s = { handle: PACKS[DATA.current] ? DATA.current : Object.keys(PACKS)[0], size: null, qty: 1 };

    /* ------------------------------ helpers ------------------------------ */
    function money(cents) {
      var fmt = DATA.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      var noDec = (cents / 100).toFixed(0);
      var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withComma)
        .replace(/<[^>]+>/g, '');
    }
    function pack() { return PACKS[s.handle]; }
    function variantFor(size) {
      var p = pack();
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].title === size) return p.variants[i];
      return null;
    }
    function $(sel, ctx) { return (ctx || document).querySelector(sel); }
    function $$(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }

    /* ------------------------------ gallery ------------------------------ */
    var mainImg = $('[data-kv2-main]');
    var thumbs = $('[data-kv2-thumbs]');

    function setMain(src, alt) {
      if (!mainImg) return;
      mainImg.classList.add('is-swapping');
      var next = new Image();
      next.onload = function () {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        if (alt != null) mainImg.alt = alt;
        mainImg.classList.remove('is-swapping');
      };
      next.onerror = function () { mainImg.classList.remove('is-swapping'); };
      next.src = src;
    }
    function bindThumbs() {
      if (!thumbs) return;
      $$('button', thumbs).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', thumbs).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          b.setAttribute('aria-current', 'true');
          setMain(b.getAttribute('data-src'), b.getAttribute('data-alt'));
        });
      });
    }
    function renderGallery() {
      var p = pack();
      if (!p.images || !p.images.length) return;
      setMain(p.images[0].src, p.images[0].alt);
      if (!thumbs) return;
      thumbs.innerHTML = '';
      thumbs.hidden = p.images.length < 2;
      p.images.forEach(function (img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.setAttribute('data-src', img.src);
        b.setAttribute('data-alt', img.alt || '');
        var im = document.createElement('img');
        im.src = img.thumb; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        thumbs.appendChild(b);
      });
      bindThumbs();
    }
    bindThumbs();

    /* ------------------------------ render ------------------------------ */
    var priceEl = $('[data-kv2-price]'), cmpEl = $('[data-kv2-compare]'), ppEl = $('[data-kv2-perpair]');
    var colourName = $('[data-kv2-colour-name]'), sizeName = $('[data-kv2-size-name]');
    var ctaText = $('[data-kv2-cta-text]'), addBtn = $('[data-kv2-add]'), errEl = $('[data-kv2-error]');
    var sticky = document.getElementById('kv2-sticky');

    function render() {
      var p = pack();
      var v = s.size ? variantFor(s.size) : null;
      var unit = v ? v.price : p.price;
      var total = unit * s.qty;

      if (priceEl) priceEl.textContent = money(unit);
      if (cmpEl) {
        if (p.compare && p.compare > unit) { cmpEl.textContent = money(p.compare); cmpEl.hidden = false; }
        else { cmpEl.hidden = true; }
      }
      if (ppEl && DATA.pairs) ppEl.textContent = money(Math.round(unit / DATA.pairs));
      if (colourName) colourName.textContent = p.label || '';
      if (sizeName) {
        var sz = (DATA.sizes || []).filter(function (x) { return x.value === s.size; })[0];
        sizeName.textContent = s.size ? (s.size + (sz && sz.age ? ' · ' + sz.age : '')) : '';
      }

      $$('[data-kv2-swatches] button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-handle') === s.handle ? 'true' : 'false');
      });
      $$('[data-kv2-sizes] .opt').forEach(function (b) {
        var sv = variantFor(b.getAttribute('data-size'));
        var ok = sv && sv.available;
        b.disabled = !ok;
        b.classList.toggle('soldout', !ok);
        b.setAttribute('aria-pressed', ok && b.getAttribute('data-size') === s.size ? 'true' : 'false');
      });
      $$('#kv2-guide tr[data-size]').forEach(function (tr) {
        tr.classList.toggle('is-on', tr.getAttribute('data-size') === s.size);
      });

      if (ctaText) {
        if (!s.size) { ctaText.textContent = DATA.pickLabel || 'pick a size first'; }
        else {
          var label = (DATA.ctaLabel || 'add {pairs} pairs to cart')
            .replace('{pairs}', DATA.pairs * s.qty)
            .replace('{price}', money(total));
          ctaText.innerHTML = '';
          ctaText.appendChild(document.createTextNode(label + ' · '));
          var pr = document.createElement('span'); pr.className = 'p'; pr.textContent = money(total);
          ctaText.appendChild(pr);
        }
      }
      if (sticky) {
        var t = $('[data-sticky-title]', sticky), n = $('[data-sticky-note]', sticky);
        if (t) t.textContent = (p.label || p.title || '') + (s.size ? ' · ' + s.size : '');
        if (n) n.textContent = money(total) + ' · ' + (DATA.pairs * s.qty) + ' pairs';
      }
    }

    /* ------------------------------ events ------------------------------ */
    $$('[data-kv2-swatches] button').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-handle');
        if (!PACKS[h] || h === s.handle) return;
        s.handle = h;
        b.classList.remove('just-picked'); void b.offsetWidth; b.classList.add('just-picked');
        // keep the size if the new pack has it in stock, otherwise clear it
        var sv = s.size ? variantFor(s.size) : null;
        if (!sv || !sv.available) s.size = null;
        renderGallery();
        render();
        clearError();
        try {
          var url = b.getAttribute('data-url');
          if (url && window.history && history.replaceState) history.replaceState(null, '', url + window.location.search);
        } catch (e) {}
      });
    });

    $$('[data-kv2-sizes] .opt').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        s.size = b.getAttribute('data-size');
        b.classList.remove('just-picked'); void b.offsetWidth; b.classList.add('just-picked');
        render();
        clearError();
      });
    });

    var qtyInput = $('[data-kv2-qty-input]');
    $$('[data-kv2-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        s.qty = Math.min(20, Math.max(1, s.qty + parseInt(b.getAttribute('data-kv2-qty'), 10)));
        if (qtyInput) qtyInput.value = s.qty;
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      s.qty = Math.min(20, Math.max(1, parseInt(qtyInput.value, 10) || 1));
      qtyInput.value = s.qty;
      render();
    });

    var guideBtn = $('[data-kv2-guide-toggle]'), guide = document.getElementById('kv2-guide');
    if (guideBtn && guide) guideBtn.addEventListener('click', function () {
      var open = guide.hidden;
      guide.hidden = !open;
      guideBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.classList.add('on');
    }
    function clearError() { if (errEl) { errEl.textContent = ''; errEl.classList.remove('on'); } }

    function add() {
      clearError();
      if (!s.size) {
        showError('Pick a size first, the ages next to each one help.');
        var firstOk = $('[data-kv2-sizes] .opt:not([disabled])');
        if (firstOk) firstOk.focus();
        return;
      }
      var v = variantFor(s.size);
      if (!v || !v.available) { showError('That size just sold out. Pick another.'); return; }
      if (addBtn) { addBtn.disabled = true; }
      var prev = ctaText ? ctaText.textContent : '';
      if (ctaText) ctaText.textContent = 'adding…';
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: s.qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (result) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result } }));
          if (ctaText) ctaText.textContent = 'added!';
          setTimeout(function () { if (addBtn) addBtn.disabled = false; render(); }, 1400);
        })
        .catch(function (err) {
          if (addBtn) addBtn.disabled = false;
          if (ctaText) ctaText.textContent = prev;
          showError((err && err.description) || 'We couldn’t add that to the cart. Please try again.');
        });
    }
    if (addBtn) addBtn.addEventListener('click', add);

    /* ------------------------------ sticky ------------------------------ */
    if (sticky) {
      var hero = document.querySelector('.kv2-hero');
      document.body.classList.add('fcv2-has-sticky');
      if ('IntersectionObserver' in window && hero) {
        new IntersectionObserver(function (entries) {
          var on = !entries[0].isIntersecting;
          sticky.classList.toggle('on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          document.body.classList.toggle('fcv2-sticky-on', on);
        }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
      }
      var sc = $('[data-kv2-sticky-cta]', sticky);
      if (sc) sc.addEventListener('click', function () {
        if (s.size) { add(); return; }
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { var f = $('[data-kv2-sizes] .opt:not([disabled])'); if (f) f.focus(); }, 500);
      });
    }

    render();
  })();
}
